/* tslint:disable */
/* eslint-disable */
/**
 * Walnut Server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 4.148.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { PartialSettingsSchemaAxeAccountFromJSON, PartialSettingsSchemaAxeAccountToJSON, } from './PartialSettingsSchemaAxeAccount';
import { PartialSettingsSchemaAxeDevtoolsProFromJSON, PartialSettingsSchemaAxeDevtoolsProToJSON, } from './PartialSettingsSchemaAxeDevtoolsPro';
import { PartialSettingsSchemaAxeDevtoolsWatcherFromJSON, PartialSettingsSchemaAxeDevtoolsWatcherToJSON, } from './PartialSettingsSchemaAxeDevtoolsWatcher';
import { PartialSettingsSchemaAxeMonitorFromJSON, PartialSettingsSchemaAxeMonitorToJSON, } from './PartialSettingsSchemaAxeMonitor';
import { PartialSettingsSchemaGeneralFromJSON, PartialSettingsSchemaGeneralToJSON, } from './PartialSettingsSchemaGeneral';
/**
 * Check if a given object implements the PartialSettingsSchema interface.
 */
export function instanceOfPartialSettingsSchema(value) {
    let isInstance = true;
    return isInstance;
}
export function PartialSettingsSchemaFromJSON(json) {
    return PartialSettingsSchemaFromJSONTyped(json, false);
}
export function PartialSettingsSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'general': !exists(json, 'general') ? undefined : PartialSettingsSchemaGeneralFromJSON(json['general']),
        'axeDevtoolsPro': !exists(json, 'axe-devtools-pro') ? undefined : PartialSettingsSchemaAxeDevtoolsProFromJSON(json['axe-devtools-pro']),
        'axeDevtoolsWatcher': !exists(json, 'axe-devtools-watcher') ? undefined : PartialSettingsSchemaAxeDevtoolsWatcherFromJSON(json['axe-devtools-watcher']),
        'axeMonitor': !exists(json, 'axe-monitor') ? undefined : PartialSettingsSchemaAxeMonitorFromJSON(json['axe-monitor']),
        'axeAccount': !exists(json, 'axe_account') ? undefined : PartialSettingsSchemaAxeAccountFromJSON(json['axe_account']),
    };
}
export function PartialSettingsSchemaToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'general': PartialSettingsSchemaGeneralToJSON(value.general),
        'axe-devtools-pro': PartialSettingsSchemaAxeDevtoolsProToJSON(value.axeDevtoolsPro),
        'axe-devtools-watcher': PartialSettingsSchemaAxeDevtoolsWatcherToJSON(value.axeDevtoolsWatcher),
        'axe-monitor': PartialSettingsSchemaAxeMonitorToJSON(value.axeMonitor),
        'axe_account': PartialSettingsSchemaAxeAccountToJSON(value.axeAccount),
    };
}
